import Sonda from '@bit/gerenciatd.utils.front-sonda';
import {
  NETFLIX_VALUES,
  TEXT_TYPES_CODES,
} from '@bit/gerenciatd.telcovid.catalog-constants';
import { updateObjectInArray } from '@bit/gerenciatd.utils.js-utils/dist/common';
import uuidv1 from 'uuid/v1';

import {
  getProductLowerPrice,
  normalizeProductSelector,
  normalizeOrderSelectors,
  getGroupByProductAlias,
} from '../../utils/productUtils';
import { USER_TYPE } from '../../constants/constants';


export const extractSelectors = (productObject, groupObjectSelector) => {
  Object.keys(productObject.product.selector).forEach((selectorKey) => {
    if (
      !groupObjectSelector[selectorKey].includes(
        productObject.product.selector[selectorKey]
      )
    ) {
      groupObjectSelector[selectorKey].push(
        productObject.product.selector[selectorKey]
      );
    }
  });

  return groupObjectSelector;
};
export const calculePreselected = (isOldCatalog, productObject) => {
  return isOldCatalog ? true : productObject.dataMap.preselected === 'true';
};
export const convertToDict = (productObject) => {
  const newDataMap = {};
  // Lógica para serializar el dataMap y que no sean objetos, sino Clave valor.
  if (productObject && productObject.product && productObject.product.dataMap) {
    productObject.product.dataMap.forEach((prop) => {
      newDataMap[prop.name] = prop.value;
    });
  }
  return newDataMap;
};

export const calculateIfGroupHavePromoOnline = (group) => {
  let isExclusiveOnline = false;
  if (group && Object.keys(group).length > 0) {
    // Ponemos todos los productos visibles.
    Object.keys(group).forEach((productKey) => {
      const productObject = group[productKey];
      if (typeof productObject === 'object') {
        if (
          productObject.product
          && productObject.product.categories
          && productObject.product.dataMap
        ) {
          const newDataMap = convertToDict(productObject);
          if (newDataMap.exclusivaOnline) {
            isExclusiveOnline = true;
          }
        }
      }
    });
  }
  return isExclusiveOnline;
};

/** Calcula la url en función del host
 * @param {object} productObject info del product
 * @param {object} environment enviroment de context
 * @returns {string}
 */
export const calculateUrlProdCompraDependsOnHost = (
  urlProdCompra,
  environment,
  userType,
) => {
  const urlProdComprePrevio = urlProdCompra;
  let result = urlProdComprePrevio;
  
  if (userType === USER_TYPE.GESTOR) {
    result = `/particulares/Aplicaciones/Telco/procesoCompra/fusion?${result.split('?')[1]}`
  }
  if (environment && environment.host && environment.host.includes('cert')) {
    result = `/cliente/venta/fusion?${urlProdComprePrevio.split('?')[1]}`;
  }
  return result;
};

/**
 * Calcula si el producto contratado de el cliente tendria una oferta de retencion
 * @param {object} infoRecom info de la recomencacion
 * @returns {object}
 */
export const calculateHiredProductRetentionOffer = (ctzBusinessClusters) => {
  if (ctzBusinessClusters) {
    if (ctzBusinessClusters.includes('prpv')) {
      const dataParsed = JSON.parse(ctzBusinessClusters);
      if (dataParsed && Array.isArray(dataParsed) && dataParsed.length > 0) {
        const filteredCtzBusinessClusters = dataParsed.filter((eachItem) => {
          return eachItem.includes('prpv');
        });
        if (
          filteredCtzBusinessClusters
          && filteredCtzBusinessClusters.length > 0
        ) {
          if (filteredCtzBusinessClusters[0].includes('_')) {
            const splitedValue = filteredCtzBusinessClusters[0].split('_');
            return { name: splitedValue[0], value: splitedValue[1] };
          }
        }
      }
    }
  }
  return null;
};

/**
 * Añade el parámetro de promo a la url si tiene promo online
 * telco => promoCode_po
 * legado => promoCode
 * @param {object} productObject producto
 * @param {string} userType tipo de usuario
 * @param {context} contexto
 * @returns {string}
 */
export const calculateUrlProdCompraDependPromoOnlineAndHost = ({
  productObject,
  userType,
  environment,
}) => {
  const newDataMap = convertToDict(productObject);
  if (newDataMap.exclusivaOnline) {
    const urlProdCompraSplited = newDataMap.urlProdCompra.split('&');
    let newUrlProcessed = '';
    urlProdCompraSplited.forEach((eachPart) => {
      if (eachPart.includes('productOffering=')) {
        if (userType === USER_TYPE.TELCO && newDataMap.promoCode_po) {
          newUrlProcessed += `${eachPart}+${newDataMap.promoCode_po}&`;
        }
      } else {
        newUrlProcessed += `${eachPart}&`;
      }
    });
    newUrlProcessed = calculateUrlProdCompraDependsOnHost(
      newUrlProcessed,
      environment,
      userType
    );
    return newUrlProcessed;
  }

  return calculateUrlProdCompraDependsOnHost(
    newDataMap.urlProdCompra,
    environment,
    userType
  );
};

/**
 * Normaliza la salida del allProducts de Custo (Que viene de turing)
 * @param {object} data Es la respuesta de customizer
 * @param {boolean} isOldCatalog Si el producto es un catalogado antiguo
 * @param {object} context context
 * @returns {(object|null)} Devuelve la respuesta del servicio normalizada o null en caso de error
 */
export const normalizeRecom = ({ data, isOldCatalog, context }) => {
  const sonda = new Sonda({
    processName: 'normalizeRecom',
    context,
    filePath: 'sagas/normalizers/fusion',
  });
  if (
    !data
    || !data.allProducts
    || Object.entries(data.allProducts).length === 0
  ) {
    sonda.severalMessage({ info: 'Data no exist' });
    return null;
  }
  // creo un diccionario con todas las propiedades del datamap
  // para acceder con notacion punto en vez de recorrer todo.
  const result = { ...data };
  result.anyHasPromoOnline = false;
  let recomendedProductAlias = null;

  if (
    result.recommendationTuring
    && Array.isArray(result.recommendationTuring)
    && result.recommendationTuring.length > 0
  ) {
    recomendedProductAlias = result.recommendationTuring[0].product.alias;
  }

  Object.keys(result.allProducts).forEach((groupKey) => {
    const groupObject = result.allProducts[groupKey];
    const groupObjectCategories = [];
    let groupObjectSelector = {
      velocidad: [],
      netflix: [],
    };
    if (Object.keys(groupObject).length > 0) {
      // Ponemos todos los productos visibles.
      groupObject.visible = true;

      Object.keys(groupObject).forEach((productKey) => {
        const productObject = groupObject[productKey];
        if (typeof productObject === 'object') {
          if (
            productObject.product
            && productObject.product.categories
            && productObject.product.dataMap
          ) {
            // extraer el datamap a un objeto accesible
            convertToDict(productObject);
            productObject.dataMap = convertToDict(productObject);

            // calcular el preseleccionado
            productObject.selected = calculePreselected(
              isOldCatalog,
              productObject
            );
            // Lógica para subir las categorías de los hijos a su padre.
            productObject.product.categories.forEach((categorie) => {
              if (!groupObjectCategories.includes(categorie)) {
                groupObjectCategories.push(categorie);
              }
            });

            productObject.dataMap.urlProdCompra = calculateUrlProdCompraDependPromoOnlineAndHost(
              {
                productObject,
                userType: context.userType,
                environment: context.environment,
              }
            );
          }

          if (productObject.product.selector) {
            groupObjectSelector = extractSelectors(
              productObject,
              groupObjectSelector
            );

            // TODO: cuando este contribuido => borrar el ternario y dejar el reduce
            productObject.selector = productObject.product.selector.velocidad.includes(
              '<span'
            )
              ? Object.keys(productObject.product.selector).reduce(
                (obj, selectorKey) => {
                  const objAux = obj;
                  objAux[selectorKey] = normalizeProductSelector(
                    productObject.product.selector[selectorKey]
                  );
                  return objAux;
                },
                {}
              )
              : productObject.product.selector;
            // delete productObject.product.selector;
          }

          // Normaliza el apartado de las "faqs" para cada producto
          if (productObject.product.faq) {
            if (
              productObject.product.faq.data
              && productObject.product.faq.h2
            ) {
              const {
                data: dataFaqs,
                h2: titleFaq,
              } = productObject.product.faq;
              const faqsNormalized = {
                header: titleFaq.replace('%20', ' '),
                questions: Object.keys(dataFaqs).map((eachFaq) => ({
                  title: eachFaq,
                  content: dataFaqs[eachFaq],
                })),
              };
              productObject.faqs = faqsNormalized;
            }
            delete productObject.product.faq;
          }
        }
      });
    } else {
      sonda.warningMessage({ info: 'EMTY GROUP' });
    }
    // Selecciona el producto con el precio menor
    const productLowerPrice = getProductLowerPrice(groupObject);

    groupObject.hasPromoOnline = calculateIfGroupHavePromoOnline(groupObject);
    if (groupObject.hasPromoOnline && groupObject && groupObjectCategories) {
      groupObjectCategories.push('PROMO-ONLINE');
    }
    if (groupObject.hasPromoOnline) {
      result.anyHasPromoOnline = true;
    }
    // groupObject[productLowerPrice.productName].selected = true;
    groupObject.categories = groupObjectCategories;
    // TODO: cuando este contribuido => borrar el ternario y dejar el reduce
    groupObject.selector = Object.keys(groupObjectSelector).reduce(
      (obj, selectorKey) => {
        const objAux = obj;
        objAux[selectorKey] = normalizeOrderSelectors(
          groupObjectSelector[selectorKey]
        )
          .sort((a, b) => {
            if (a.weight > b.weight) {
              return 1;
            }
            return -1;
          })
          .map((eachSelector) => eachSelector.text);
        return objAux;
      },
      {}
    );
    groupObject.priceOrder = parseFloat(
      groupObject[productLowerPrice.productName].dataMap.pvp,
      10
    );
    groupObject.id = groupKey;
    groupObject.recomended = false;
  });
  const copyAllProducts = JSON.parse(JSON.stringify(result.allProducts));
  const { groupProductsKey } = getGroupByProductAlias(
    recomendedProductAlias,
    copyAllProducts
  );
  if (data && data.infoRecom && data.infoRecom.ctz_businessClusters) {
    const hiredPreventionPromotions = calculateHiredProductRetentionOffer(
      data.infoRecom.ctz_businessClusters
    );
    let prpvCode = '';
    if (hiredPreventionPromotions && hiredPreventionPromotions.value) {
      prpvCode = hiredPreventionPromotions.value;
    }
    result.prpvCode = prpvCode;
  }
  if (
    result.recommendationTuring
    && Array.isArray(result.recommendationTuring)
    && result.recommendationTuring.length > 0
  ) {
    if (groupProductsKey) {
      result.allProducts[groupProductsKey].recomended = true;

      const content = result.allProducts[groupProductsKey];
      const contentKeys = Object.keys(content);

      contentKeys.forEach((key) => {
        const productObject = content[key];
        if (typeof productObject === 'object' && key !== 'selector') {
          content[key].selected = false;
        }
      });
      let contentAlias = '';
      let webCode = '';

      if (data && data.infoRecom && data.infoRecom.ctz_webCode) {
        webCode = data.infoRecom.ctz_webCode;
      }
      contentAlias = Object.keys(content).find((element) => {
        if (typeof content[element].product !== 'undefined') {
          if (content[element].product.alias === recomendedProductAlias) {
            return element;
          }
        }
        return undefined;
      });
      const urlProdCompraRecom = content[contentAlias].dataMap.urlProdCompra;

      if (contentAlias) {
        if (webCode) {
          // TODO quitado para probar si deja de concatenarse en el flyout
          if (urlProdCompraRecom.indexOf('?') !== -1) {
            content[
              contentAlias
            ].dataMap.urlProdCompra = `${urlProdCompraRecom}&prevPosCode=pc000001&prevPhCode=ph000023&prevWebCode=${webCode}`;
          } else {
            content[
              contentAlias
            ].dataMap.urlProdCompra = `${urlProdCompraRecom}?prevPosCode=pc000001&prevPhCode=ph000023&prevWebCode=${webCode}`;
          }
        }
        content[
          contentAlias
        ].dataMap.urlProdCompra = calculateUrlProdCompraDependsOnHost(
          content[contentAlias].dataMap.urlProdCompra,
          context.environment,
          context.userType
        );
      }
      content[contentAlias].selected = true;
    }
  }
  return result;
};

const EXCLUDE_CATEGORIES = ['CANAL TV', 'DISNEY', 'MOTOR'];

let channels = [];

const isChannel = (candidate) => candidate.idTemplate === 4854465514962944;

const isBasePack = (candidate) => !!candidate.subProducts && candidate.alias.indexOf('contratable') === -1;

const getInnerProperty = (dataMap, property) => dataMap.find((x) => x.name.toLowerCase() === property.toLowerCase()).value
  || '';

const searchForChannels = (pack) => {
  if (isChannel(pack) && !isBasePack(pack)) {
    channels.push({
      categoria1: pack.categories[0],
      categoria: getInnerProperty(pack.dataMap, 'categoria'),
      claim: getInnerProperty(pack.dataMap, 'claim'),
      dial: getInnerProperty(pack.dataMap, 'dial'),
      icono: getInnerProperty(pack.dataMap, 'icono'),
      nombre: pack.name,
      urlFicha: getInnerProperty(pack.dataMap, 'urlFicha'),
    });
  } else if (isBasePack(pack)) {
    searchForChannels(pack.subProducts.map(searchForChannels));
  }
};

const sortChannelsByCategory = (key) => {
  channels.sort((a, b) => {
    if (a[key] > b[key]) return 1;
    if (a[key] < b[key]) return -1;
    return 0;
  });
};

const deleteRepeatedChannels = () => channels.reduce((acc, curr) => {
  if (
    !acc.find(
      (x) => x.nombre === curr.nombre
          && x.categoria1 === curr.categoria1
          && x.icono === curr.icono
    )
  ) { acc.push(curr); }
  return acc;
}, []);

const excludeChannels = () => channels.filter((x) => !EXCLUDE_CATEGORIES.includes(x.categoria1));

/**
 *
 * @param {object} objectToSearchFrom Objeto desde el que empezar a buscar y clasificar canales
 * @returns {array} Devuelve lista de canales
 */
export const normalizeChannels = (objectToSearchFrom) => {
  searchForChannels(objectToSearchFrom);
  sortChannelsByCategory('categoria1');
  channels = deleteRepeatedChannels();
  channels = excludeChannels();
  return channels;
};
/**
 * Normaliza la salida del producto de prevencion de Custo
 * @param {object} data Es la respuesta de customizer
 * @param {boolean} isOldCatalog Si el producto es un catalogado antiguo
 * @param {string} environment environment donde se ha cargado la página
 * @returns {(object|null)} Devuelve la respuesta del servicio normalizada o null en caso de error
 */
export const normalizePrevention = ({ data, isOldCatalog, context }) => {
  let normalicedPrevention = null;
  if (data && data.allProducts) {
    normalicedPrevention = normalizeRecom({ data, isOldCatalog, context })
      .allProducts;
  }
  return normalicedPrevention;
};

export const getPhoneProductsDependency = (hiredProduct) => {
  const phoneArray = [];
  if (hiredProduct.phone) {
    hiredProduct.phone.linesPhone.forEach((lines) => {
      lines.productosContratadosDedependientes.forEach((product) => {
        phoneArray.push(product);
      });
    });
  }

  return phoneArray;
};

export const getMobileProductsDependency = (hiredProduct) => {
  const mobileArray = [];

  if (hiredProduct.mobile) {
    hiredProduct.mobile.linesMobile.forEach((lines) => {
      lines.productosContratadosDedependientes.forEach((product) => {
        mobileArray.push(product);
      });
    });
  }

  return mobileArray;
};
export const getInternetProductsDependency = (hiredProduct) => {
  const internetArray = [];
  if (hiredProduct.internet) {
    hiredProduct.internet.productosContratadosDedependientes.forEach(
      (product) => {
        internetArray.push(product);
      }
    );
  }
  return internetArray;
};

export const getTvProductsDependency = (hiredProduct) => {
  const tvArray = [];
  if (hiredProduct.tv) {
    hiredProduct.tv.productosContratadosDedependientes.forEach((product) => {
      tvArray.push(product);
    });
  }
  return tvArray;
};

export const getProductByPOId = (hiredProducts, poId) => {
  let product = hiredProducts.find(
    (x) => x.poId === poId || x.bundleId === poId
  );
  if (!product) {
    hiredProducts.forEach((hiredProduct) => {
      const {
        internet, mobile, phone, tv,
      } = hiredProduct;
      if (internet) {
        if (internet.poId === poId) {
          product = internet;
        } else {
          const productFound = getInternetProductsDependency(hiredProduct).find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (mobile && !product) {
        const { linesMobile } = mobile;
        if (linesMobile && Array.isArray(linesMobile)) {
          const productFound = linesMobile.find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
        if (!product) {
          const productFound = getMobileProductsDependency(hiredProduct).find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (phone && !product) {
        const { linesPhone } = phone;
        if (linesPhone && Array.isArray(linesPhone)) {
          const productFound = linesPhone.find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
        if (!product) {
          const productFound = getPhoneProductsDependency(hiredProduct).find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
      if (tv && !product) {
        if (tv.poId === poId) {
          product = tv;
        } else {
          const productFound = getTvProductsDependency(hiredProduct).find(
            (x) => x.poId === poId || x.bundleId === poId
          );
          if (productFound) {
            product = productFound;
          }
        }
      }
    });
  }
  return product;
};

export const getFirstProductByPoIdOnCertainProduct = (
  productStructure,
  poIds
) => {
  let product = null;
  if (productStructure) {
    if (
      poIds.includes(productStructure.poId)
      || poIds.includes(productStructure.bundleId)
    ) {
      product = productStructure;
    }
    const {
      internet, mobile, phone, tv,
    } = productStructure;
    if (internet && !product) {
      if (poIds.includes(internet.poId) || poIds.includes(internet.bundleId)) {
        product = internet;
      } else {
        const productFound = getInternetProductsDependency(
          productStructure
        ).find((x) => poIds.includes(x.poId) || poIds.includes(x.bundleId));
        if (productFound) {
          product = productFound;
        }
      }
    }
    if (mobile && !product) {
      const { linesMobile } = mobile;
      if (linesMobile && Array.isArray(linesMobile)) {
        const productFound = linesMobile.find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
      if (!product) {
        const productFound = getMobileProductsDependency(productStructure).find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
    }
    if (phone && !product) {
      const { linesPhone } = mobile;
      if (linesPhone && Array.isArray(linesPhone)) {
        const productFound = linesPhone.find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
      if (!product) {
        const productFound = getPhoneProductsDependency(productStructure).find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
    }
    if (tv && !product) {
      if (poIds.includes(tv.poId) || poIds.includes(tv.bundleId)) {
        product = tv;
      } else {
        const productFound = getTvProductsDependency(productStructure).find(
          (x) => poIds.includes(x.poId) || poIds.includes(x.bundleId)
        );
        if (productFound) {
          product = productFound;
        }
      }
    }
  }
  return product;
};
export const NETFLIX_PRODUCT_OFFERING = '496';
export const FUSION = 0;
export const NETFLIX_TEXTS = {
  X2: 'X2',
  X4: 'X4',
};
export const getCatalogueProductOfferingNormalizer = (
  hiredProducts,
  productOffering
) => {
  const productOfferingNormalized = productOffering;
  if (hiredProducts && Array.isArray(hiredProducts)) {
    const { id, texts } = productOffering;
    const productSelected = getProductByPOId(hiredProducts, id);
    if (productSelected) {
      const { productType } = productSelected;
      if (productType === FUSION) {
        const netflixProduct = getFirstProductByPoIdOnCertainProduct(
          productSelected,
          [NETFLIX_PRODUCT_OFFERING]
        );
        if (netflixProduct) {
          const { characteristics } = netflixProduct;
          if (characteristics && Array.isArray(characteristics)) {
            const netflixModality = characteristics.find(
              (char) => char.valueId === NETFLIX_VALUES.STANDARD
                || char.valueId === NETFLIX_VALUES.PRIME
            );
            const ordinaryTextIndex = texts.findIndex(
              (text) => text.typeId === TEXT_TYPES_CODES.ORDINARY
            );
            if (netflixModality && ordinaryTextIndex !== -1) {
              let { text } = texts[ordinaryTextIndex];
              if (text) {
                if (netflixModality.valueId === NETFLIX_VALUES.STANDARD) {
                  text = `${text} ${NETFLIX_TEXTS.X2}`;
                } else if (netflixModality.valueId === NETFLIX_VALUES.PRIME) {
                  text = `${text} ${NETFLIX_TEXTS.X4}`;
                }
                productOfferingNormalized.texts = updateObjectInArray(
                  texts,
                  ordinaryTextIndex,
                  { text }
                );
              }
            }
          }
        }
      }
    }
  }
  return productOfferingNormalized;
};

export const getUUID = () => {
  const v1options = {
    node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
    clockseq: 0x1234,
    msecs: new Date().getTime(),
    nsecs: 5678,
  };
  let uuid = uuidv1(v1options);
  uuid = uuid.replace(/-/g, '');
  uuid = uuid.toUpperCase();
  return `${uuid}`;
};
